import React, { useEffect, useRef, useState } from "react";
import * as S from "./ChatbotPatientCase.style"
import { useLazyQuery, useMutation } from "@apollo/client";
import { CONSULT_PATIENT_HISTORY_CHAT_IN_FLORENCE, GENERATE_PATIENT_GUIDE_FILE, UPDATE_PATIENT_GUIDE_FILE } from "../../../../../../graphql/mutations/Chat";
import useSize from "../../../../../../hooks/useSize";
import { useTranslation } from "react-i18next";
import useDoctorData from "../../../../../../hooks/useDoctorData";
import ZaialoadingPoints from "../../../../../zaiaComponents/zaiaLoadingPoints";
import ChatbotInput from "../../chatbotInput";
import Message from "../../message";
import ModalSelectPatient from "../../../../shared/modals/modalSelectPatient";
import Modal from "../../../../../../utils/modal";
import ZaiaReaction from "../../../../../zaiaComponents/zaiaReaction";
import ZaiaModalResponseContent from "../../../../../zaiaComponents/zaiaModalResponseContent";
import FlorenzButton from "../../../../../florenzComponents/florenzButton/FlorenzButton";

const bgChatbot = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/chat-background.svg`;
const monacoChatbot = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/monaco-logo.svg`
const defaultPatientImg = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaImgDefault/default-user2.svg`;
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;


function ChatbotPatientCase(
  {
    selectedPatient,
    setActiveModalPatient
  }
) {

  const footerRef = useRef();
  const { height } = useSize(footerRef);
  const element = document.getElementById("chatbot-container");
  const {t, i18n: { language }} = useTranslation("global");
  const { doctorData } = useDoctorData();
  const [successUpdateGuide, setSuccessUpdateGuide] = useState(null);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    patientMessage(values.msg, 'doctor');
    sendBotMessage(values.msg, setSubmitting, resetForm);
    autoScroll();
  };

  const sendBotMessage = async (msg, setSubmitting, resetForm) => {    
    try {
      if(resetForm) resetForm();
      if(setSubmitting) setSubmitting(false);
      sendChatbotMessage(msg);
    } catch (error) {
      console.log(error);
    }
  }

  const patientMessage = (msg, type) => {
    let allMessages = messages;
    allMessages.push(
      {
        id: Date.now(),
        message: msg,
        senderName: `${doctorData.name} ${doctorData.lastname}`,
        type: type
      }
    )
    setMessages([...allMessages])
  }

  const autoScroll = () => {
    if(element) element.scrollTop = element.scrollHeight - element.clientHeight;
  }

  const [chatBotPatient, {loading: chatBotPatientLoading}] = useLazyQuery(
    CONSULT_PATIENT_HISTORY_CHAT_IN_FLORENCE,
    {
      fetchPolicy: "network-only"
    }
  );

  const [generatePatientGuideFile, {loading: generatePatientGuideFileLoading}] = useMutation(
    GENERATE_PATIENT_GUIDE_FILE,
    {
      fetchPolicy: "network-only"
    }
  );

  const [updatePatientGuideFile, {loading: updatePatientGuideFileLoading}] = useMutation(
    UPDATE_PATIENT_GUIDE_FILE,
    {
      fetchPolicy: "network-only"
    }
  );

  const sendChatbotMessage = async (msg) => {
    const {
      data: {
        consult_medical_history_in_florence,
      },
    } = await chatBotPatient({
      variables: {
        language: language.split('-')[0],
        question: `${msg} ${t("globally.sourcesCaption")}`,
        user_id: selectedPatient?.id
      },
    });

    if (!chatBotPatientLoading ) {
      setMessages(
        [
          ...messages,
          {
            id: Date.now(),
            message: consult_medical_history_in_florence.answer,
            senderName: t("globally.chatbotName"),
            type: 'bot',
          }
        ]
      )
      autoScroll()
    }
  }
  
  const [messages, setMessages] = useState([]);

  const generatePatientGuideFileHandler = async () => {
    try {
      const {
        data: {
          generate_patient_pdf_report,
        },
      } = await generatePatientGuideFile({
        variables: {
          userId: selectedPatient?.id
        },
      });
      if(generate_patient_pdf_report.pdfSaveStatus.success) {
        const {
          data: {
            upload_patient_medical_history,
          },
        } = await updatePatientGuideFile({
          variables: {
            userId: selectedPatient?.id,
            fileName: selectedPatient?.id + ".pdf",
            fileBucketName: "zaia-health-dev_user_clinical_history_pdf"
          },
        });
        
        if(upload_patient_medical_history.error_message === null) {
          setSuccessUpdateGuide(true);
        }
      }
    } catch (error) {
      console.log(error);
      setSuccessUpdateGuide(false);
    }
  }

  useEffect(() => {
  }, [height, generatePatientGuideFileLoading, updatePatientGuideFileLoading])

  return (
    <S.ChatbotPatientCase 
      selectedPatient={selectedPatient}
    >
      {
        (generatePatientGuideFileLoading || updatePatientGuideFileLoading) &&
        <ZaiaReaction
          widthimg={"150px"}
          zaiaImg={logoZaiaLoading} 
          padding={"200px 0px"}
        />
      }
      {
        !(generatePatientGuideFileLoading || updatePatientGuideFileLoading) && 
        <>
          {
            <Modal open={successUpdateGuide !== null}>
              <S.ModalResponseReaction>
                  <div className="modal-background" onClick={() => setSuccessUpdateGuide(null)}>
                  </div>
                  <div className="modal-container">
                    <ZaiaModalResponseContent
                      button1={() => setSuccessUpdateGuide(null)}
                      // button2={() => setActiveConfirmModal(false)}
                      formSuccess={successUpdateGuide}
                      button1Text={successUpdateGuide ? t("followUp.confirm") : t("globally.cancel")}
                      title={successUpdateGuide ? t("chatbotAI.uploadGuideSuccess") : t("chatbotAI.uploadGuideError")}
                    />
                  </div>
              </S.ModalResponseReaction>
            </Modal>
          }
          {/* { 
            <Modal open={activeModalPatient}>
              <ModalSelectPatient
                setModalActive={setActiveModalPatient}
                setPatient={selectPatient}
              />
            </Modal>
          } */}
          <div className="chatbot-container" id="chatbot-container">
            {
              messages.length === 0 &&
              <div className="chatbot-container__empty">
                <div className="chatbot-container__empty-container">
                  <img src={monacoChatbot} alt="" className="chatbot-container__empty-image" />
                  <div className="chatbot-container__empty-container__shadow"></div>
                </div>
                <div className="chatbot-container__empty-msg">  
                  {t("chatbotAI.patients.letsTalk")}
                </div>
              </div>
            }
            {messages.map((message, index) => (
              <div key={message.id}>
                { 
                  <Message
                    key={index}
                    message={message.message?.replace('0chatgpt', '')}
                    senderName={message.senderName}
                    option={message.type}
                  />
                }
              </div>
            ))}
            { 
              chatBotPatientLoading
              ? <Message
                senderName={t("globally.chatbotName")}
              >
                <ZaialoadingPoints />
              </Message> 
              : null
            }
          </div>
          {
            <div className="chatbot-footer" ref={footerRef}>
              {
                selectedPatient
                ? <>
                  <ChatbotInput
                    chatbotDisabled={!selectedPatient}
                    disabledText={t("chatbotAI.patients.inputCondition")}
                    handleSubmit={handleSubmit}
                  />
                  <div className="patient-selected-content">
                    <div className="patient-selected" onClick={() => setActiveModalPatient(true)}>
                      <div className="patient-selected__box-image">
                        <img src={selectedPatient.picture ?? defaultPatientImg} alt="user" className="patient-selected__image" />
                      </div>
                      <div className="patient-selected__name">
                        {`${selectedPatient.name} ${selectedPatient.lastname}`}
                      </div>
                      <i className="patient-selected__icon-close zaia-icono-cerrar"></i>
                    </div>
                    <div 
                      className="patiet-selected__update-guide"
                      onClick={() => generatePatientGuideFileHandler()}
                    >
                      {t("chatbotAI.updateGuide")}
                      <i className="patient-selected__icon-update zaia-i-refresh"></i>
                    </div>
                  </div> 
                </>
                : <div className="button-selection">
                  <FlorenzButton
                    typeStyle={"primary"}
                    size="m"
                    text={t("chatbotAI.selectPatient")}
                    widthComplete={true}
                    icon={"zaia-i-person"}              
                    onClick={() => {
                      setActiveModalPatient(true)
                    }}
                  />
                </div>
              }
            </div>
          }
        </>
      }
    </S.ChatbotPatientCase>
  );

}

export default ChatbotPatientCase;
